import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'column',
    paddingBottom: 12.5,
  },
  container: {
    marginRight: 9,
    marginLeft: 9,
  },
  header: {
    marginTop: 10,
  },
});
